export const LIMIT_CHARS_TO_REQUEST = 3
export const REQUEST_TIMEOUT = 500
